import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { resolveTenantUrl, tenantOverrideOptions } from 'src/app/Common/ApiConfigurationService/resolve-tenant-url.util';
import {
  CustomHtmlMasterCreateRequestDTO,
  CustomHtmlMasterUpdateRequestDTO,
  CustomHtmlMasterDeleteRequestDTO,
  CustomHtmlMasterReadByIdRequestDTO,
  CustomHtmlMasterReadByTenantIdRequestDTO,
  CustomHtmlMasterReadByMasterIdRequestDTO,
  CustomHtmlMasterReadByTemplateIdRequestDTO,
  CustomHtmlMasterItem,
  CustomHtmlMasterList,
  CustomHtmlMasterReadAllPaginatedRequestDTO,
  CustomHtmlMasterReadByParentDivIdRequestDTO
} from './CustomHtmlMaster.interface';

import {
  CustomHtmlMaster_Create,
  CustomHtmlMaster_Update,
  CustomHtmlMaster_Delete,
  CustomHtmlMaster_ReadAll,
  CustomHtmlMaster_ReadById,
  CustomHtmlMaster_ReadByTenantId,
  CustomHtmlMaster_ReadByMasterId,
  CustomHtmlMaster_ReadByTemplateId,
  CustomHtmlMaster_ReadAllPaginated,
  CustomHtmlMaster_ReadByParentDivId
} from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class CustomHtmlMasterService {

  http = inject(HttpClient);


  CustomHtmlMaster_Create(data: CustomHtmlMasterCreateRequestDTO): Observable<CustomHtmlMasterItem> {
    return this.http.post<CustomHtmlMasterItem>(CustomHtmlMaster_Create, data);
  }

  CustomHtmlMaster_Update(data: CustomHtmlMasterUpdateRequestDTO): Observable<CustomHtmlMasterItem> {
    return this.http.post<CustomHtmlMasterItem>(CustomHtmlMaster_Update, data);
  }


  CustomHtmlMaster_Delete(data: CustomHtmlMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(CustomHtmlMaster_Delete, data);
  }


  CustomHtmlMaster_ReadAll(): Observable<CustomHtmlMasterList> {
    return this.http.get<CustomHtmlMasterList>(CustomHtmlMaster_ReadAll, {});
  }


  CustomHtmlMaster_ReadById(data: CustomHtmlMasterReadByIdRequestDTO): Observable<CustomHtmlMasterItem> {
    return this.http.post<CustomHtmlMasterItem>(CustomHtmlMaster_ReadById, data);
  }


  CustomHtmlMaster_ReadByTenantId(data: CustomHtmlMasterReadByTenantIdRequestDTO): Observable<CustomHtmlMasterList> {
    return this.http.post<CustomHtmlMasterList>(CustomHtmlMaster_ReadByTenantId, data);
  }


  CustomHtmlMaster_ReadByMasterId(data: CustomHtmlMasterReadByMasterIdRequestDTO): Observable<CustomHtmlMasterList> {
    return this.http.post<CustomHtmlMasterList>(CustomHtmlMaster_ReadByMasterId, data);
  }


  CustomHtmlMaster_ReadByTemplateId(data: CustomHtmlMasterReadByTemplateIdRequestDTO): Observable<CustomHtmlMasterList> {
    return this.http.post<CustomHtmlMasterList>(CustomHtmlMaster_ReadByTemplateId, data);
  }

  // baseUrlOverride (optional): the viewed tenant's own AM gateway origin,
  // e.g. CompanyDetailComponent.apiConfigOverride.am. companyId/branchId
  // (required whenever baseUrlOverride is passed): the VIEWED tenant's own
  // id/branch, sent as CompanyId/BranchId headers instead of the logged-in
  // admin's own - otherwise the request reaches the right server with the
  // wrong tenant's headers and 404s there. Omitted for every other caller
  // (this service is shared by 14+ other files) - behaves exactly as before.
  CustomHtmlMaster_ReadAllPaginated(data: CustomHtmlMasterReadAllPaginatedRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<CustomHtmlMasterList> {
    return this.http.post<CustomHtmlMasterList>(resolveTenantUrl(CustomHtmlMaster_ReadAllPaginated, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
  }

  CustomHtmlMaster_ReadByParentDivId(data: CustomHtmlMasterReadByParentDivIdRequestDTO): Observable<CustomHtmlMasterList> {
    return this.http.post<CustomHtmlMasterList>(CustomHtmlMaster_ReadByParentDivId, data);
  }


}
